var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-card" },
    [
      _vm.immediateCharge
        ? _c("div", { staticClass: "text-danger help-text" }, [
            _vm._v("\n    Your card will be charged straight away.\n  "),
          ])
        : _c("div", { staticClass: "help-text" }, [
            _vm._v(
              "\n    Your card won't be charged until your order is ready to go out.\n  "
            ),
          ]),
      _vm._v(" "),
      _c("integrapay-card-storage", {
        ref: "cardForm",
        attrs: {
          "input-config": _vm.integrapayConfig,
          callback: _vm.processCreditCard,
        },
        on: { "valid-card": _vm.validCard },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }